<template>
    <div>
        <div style="text-align:center;width: 50%;margin: 0 auto;">
            <h1>Waters Contracting</h1>
                <p>
                    Waters Contracting is a full service landscape contractor.
                    Specializing in irrigation systems, including home sprinkler systems.
                    We perform full system installations, repairs, back flow installation and testing.
                </p>
                <p>
                    Waters Contracting is located in Layton, Utah and services Weber, Davis, Salt Lake, and Morgan Counties.
                </p>
                <img alt="Waters Contracting trailer" src="../assets/trailer.jpg" style="width:50%;"/>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Index',
}
</script>